
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4993d180\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss\",\"/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./category.vue")
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4993d180\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss\",\"/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./category.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./category.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4993d180\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./category.vue"),
  /* scopeId */
  "data-v-4993d180",
  /* cssModules */
  null
)
Component.options.__file = "/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/view/wxapp/category.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] category.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4993d180", Component.options)
  } else {
    hotAPI.reload("data-v-4993d180", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/wxapp/category.vue
// module id = 2378
// module chunks = 0